import React from "react";

const GENDER_ENUMS = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
};

const GenderGraph = ({
  male = { percentage: 0, count: 0 },
  female = { percentage: 0, count: 0 },
  other = { percentage: 0, count: 0 },
}) => {
  return (
    <div className="d-flex flex-column align-items-start justify-content-center h-100 w-100 gap-3 px-4">
      <Gender
        gender={GENDER_ENUMS?.MALE}
        percentage={male.percentage}
        count={male.count}
      />
      <Gender
        gender={GENDER_ENUMS?.FEMALE}
        percentage={female.percentage}
        count={female.count}
      />
      <Gender
        gender={GENDER_ENUMS?.OTHER}
        percentage={other.percentage}
        count={other.count}
      />
    </div>
  );
};

const Gender = ({ gender = GENDER_ENUMS.MALE, percentage = 0, count = 0 }) => {
  const genderContextData = {
    [GENDER_ENUMS.MALE]: {
      color: "#ffc21c",
      icon: <MaleIcon />,
      name: "Male",
    },
    [GENDER_ENUMS.FEMALE]: {
      color: "#1c9dff",
      icon: <FemaleIcon />,
      name: "Female",
    },
    [GENDER_ENUMS.OTHER]: {
      color: "#6a5acd",
      icon: <OtherIcon />,
      name: "Other",
    },
  };

  const containerStyle = {
    position: "relative",
    width: "auto",
    aspectRatio: "1/1",
    height: "100%",
    minHeight: "70px",
    // maxHeight: "100px",
    borderRadius: "50%",
    overflow: "hidden",
    backgroundColor: "#ddd",
  };

  const fillStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: `conic-gradient(${genderContextData[gender]?.color} ${percentage}%, #f5f5f5 ${percentage}%)`,
    borderRadius: "50%",
    transition: "background 1s linear",
    zIndex: 1,
  };

  return (
    <div className="d-flex flex-row align-items-center justify-content-center h-100 gap-2">
      <div style={containerStyle}>
        <div style={fillStyle}></div>
        <div
          className="d-flex flex-column align-items-center justify-content-center shadow"
          style={{
            borderRadius: "100px",
            backgroundColor: "white",
            zIndex: 2,
            position: "absolute",
            top: 7,
            left: 7,
            right: 7,
            bottom: 7,
          }}
        >
          {genderContextData[gender]?.icon}
        </div>
      </div>

      <div className="d-flex flex-column align-items-start justify-content-center gap-1">
        <h6 className="m-0">{genderContextData[gender]?.name}</h6>
        <span>{count} Appointments</span>
      </div>
    </div>
  );
};

const MaleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="30px"
      viewBox="0 -960 960 960"
      width="30px"
      fill="#ffc21c"
    >
      <path d="M400-80v-280h-80v-240q0-33 23.5-56.5T400-680h160q33 0 56.5 23.5T640-600v240h-80v280H400Zm80-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Z" />
    </svg>
  );
};

const FemaleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="30px"
      viewBox="0 -960 960 960"
      width="30px"
      fill="#1c9dff"
    >
      <path d="M400-80v-240H280l122-308q10-24 31-38t47-14q26 0 47 14t31 38l122 308H560v240H400Zm80-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Z" />
    </svg>
  );
};

const OtherIcon = () => {
  return <div>Other</div>;
};

export default GenderGraph;
